export default "__VITE_ASSET__BQwkKmvj__"